import { render, staticRenderFns } from "./courseScheduleManage.vue?vue&type=template&id=1e65dff4&scoped=true"
import script from "./courseScheduleManage.vue?vue&type=script&lang=js"
export * from "./courseScheduleManage.vue?vue&type=script&lang=js"
import style0 from "./courseScheduleManage.vue?vue&type=style&index=0&id=1e65dff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65dff4",
  null
  
)

export default component.exports